import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  rootMFA: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(4),
      display: "flex",
      justifyContent: "center",
    },
  },

  welcomeBanner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  containerMFA: {
    marginTop: theme.spacing(8),
    backgroundColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(6),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
  },

  titleMFA: {
    fontFamily: "MontserratBold",
    fontWeight: 800,
    fontSize: 56,
    lineHeight: 1.2,
    textAlign: "left",
    marginTop: 0,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: 36,
      textAlign: "center",
    },
  },

  textExplainMFA: {
    fontFamily: "Montserrat",
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 1.5,
    textAlign: "left",
    marginBottom: theme.spacing(5),
    color: theme.palette.text.primary,
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      fontSize: 16,
      marginBottom: theme.spacing(3),
    },
  },

  formMFA: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      gap: theme.spacing(2),
    },
  },

  labelsMFA: {
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: 18,
    textAlign: "left",
    color: theme.palette.text.tertiary,
    height: 24,
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },

  passwordHelper: {
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: 12,
    textAlign: "left",
    color: theme.palette.text.tertiary,
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      marginLeft: 0,
    },
  },

  containerButtons: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },

  otpInput: {
    width: 50,
    height: 55,
    textAlign: "center",
    fontSize: 20,
    borderRadius: 8,
    border: `1px solid ${
      theme.palette.borderSelect.border || theme.palette.divider
    }`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    transition: "all 0.25s ease-in-out",

    "&:hover": {
      transform: "scale(1.05)",
      borderColor:
        theme.palette.borderSelect.border || theme.palette.primary.main,
    },

    "&:focus": {
      outline: "none",
      borderColor:
        theme.palette.borderSelect.borderFocus || theme.palette.primary.main,
      transform: "scale(1.08)",
    },

    [theme.breakpoints.down("xs")]: {
      width: 40,
      height: 48,
      fontSize: 18,
    },
  },
}));

export default useStyles;
